import { render, staticRenderFns } from "./agentlogin.vue?vue&type=template&id=2a1df92a&scoped=true"
import script from "./agentlogin.vue?vue&type=script&lang=js"
export * from "./agentlogin.vue?vue&type=script&lang=js"
import style0 from "./agentlogin.vue?vue&type=style&index=0&id=2a1df92a&prod&lang=css"
import style1 from "./agentlogin.vue?vue&type=style&index=1&id=2a1df92a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1df92a",
  null
  
)

export default component.exports